// Dependencies
import { FC, MouseEventHandler, ReactElement } from "react";

// Styles
import { StyledMenu } from "./OptionMenu.styled";

interface OptionMenuProps {
  children: ReactElement | ReactElement[];
  open: boolean;
  anchorEl: null | HTMLElement;
  id: string;
  onClose: MouseEventHandler;
}

const OptionMenu: FC<OptionMenuProps> = ({ children, ...props }) => {
  return (
    <StyledMenu
      {...props}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      {children}
    </StyledMenu>
  );
};

export default OptionMenu;
